import React from "react";
import { BadgeCheck, ShieldCheck, IdCard, FileCheck } from "lucide-react";

const BADGE_MAP = {
  business_verified: { label: "Attività verificata", Icon: BadgeCheck },
  registry_verified: { label: "Iscrizione verificata", Icon: ShieldCheck },
  identity_verified: { label: "Identità verificata", Icon: IdCard },
  criminal_record: { label: "Casellario presentato", Icon: FileCheck },
};

export function Badges({ badges = [], size = "sm" }) {
  if (!badges.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="profile-badges">
      {badges.map((b) => {
        const info = BADGE_MAP[b];
        if (!info) return null;
        const { label, Icon } = info;
        return (
          <span
            key={b}
            data-testid={`badge-${b}`}
            className="inline-flex items-center gap-1 rounded-full bg-[#E8F5E9] text-[#2E7D32] px-2 py-0.5 text-xs font-medium"
          >
            <Icon size={13} strokeWidth={2} /> {label}
          </span>
        );
      })}
    </div>
  );
}
